import React, { useState, useContext } from "react";
import { AudioContext } from "../../contexts/AudioContext";
import { Link, useHistory } from "react-router-dom";
import firebase from "firebase";
import "./style.scss";

const SignIn = () => {
  const audioContext = useContext(AudioContext);
  const [isLoading, setLoading] = useState(false);
  const [existingEmail, setExistingEmail] = useState("");
  const [pendingCred, setPendingCred] = useState("");
  const [isOpenAlert, setOpenAlert] = useState(false);
  const history = useHistory();
  const db = firebase.firestore();
  // const audio = new Audio(require("../../assets/audio/loading.mp3"));
  const handleClickGoogle = async () => {
    // const elem = document.getElementById("root");
    // if (elem.requestFullscreen) {
    //   elem.requestFullscreen();
    // } else if (elem.mozRequestFullScreen) {
    //   /* Firefox */
    //   elem.mozRequestFullScreen();
    // } else if (elem.webkitRequestFullscreen) {
    //   /* Chrome, Safari and Opera */
    //   elem.webkitRequestFullscreen();
    // } else if (elem.msRequestFullscreen) {
    //   /* IE/Edge */
    //   elem.msRequestFullscreen();
    // }
    setLoading(true);
    audioContext.volumeDown();
    const provider = new firebase.auth.GoogleAuthProvider();
    provider.setCustomParameters({
      display: "popup",
    });
    await firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        // let token = result.credential.accessToken;
        let user = result.user;
        localStorage.email = user.email;
        localStorage.name = user.displayName;
        localStorage.photo = user.photoURL;
        let docRef = db.collection("users").doc(user.email);
        docRef.get().then((doc) => {
          if (doc.exists) {
            if (doc.data().nickName) {
              localStorage.nickName = doc.data().nickName;
            }
            if (doc.data().photo) {
              localStorage.photo = doc.data().photo;
            }
            if (doc.data().score) {
              localStorage.score = doc.data().score;
            }
            docRef
              .update({
                token: localStorage.token ? localStorage.token : "",
              })
              .then((doc) => {
                db.collection("users")
                  .doc(user.email)
                  .get()
                  .then((doc) => {
                    audioContext.volumeUp();
                    history.push("/luckygame");
                    setLoading(false);
                  });
              });
          } else {
            db.collection("users")
              .doc(user.email)
              .set({
                email: user.email,
                name: user.displayName,
                nickName: user.displayName,
                photo: user.photoURL,
                lastScore: 0,
                lastStatus: "unlucky",
                score: 0,
                type: "h",
                token: localStorage.token ? localStorage.token : "",
                notify: true,
              })
              .then((docRef) => {
                localStorage.nickName = "";
                history.push("/nickname");
              });
          }
        });
      })
      .catch((error) => {
        setLoading(false);
        audioContext.volumeUp();
      });
  };

  const handleClickFacebook = async () => {
    // const elem = document.getElementById("root");
    // if (elem.requestFullscreen) {
    //   elem.requestFullscreen();
    // } else if (elem.mozRequestFullScreen) {
    //   /* Firefox */
    //   elem.mozRequestFullScreen();
    // } else if (elem.webkitRequestFullscreen) {
    //   /* Chrome, Safari and Opera */
    //   elem.webkitRequestFullscreen();
    // } else if (elem.msRequestFullscreen) {
    //   /* IE/Edge */
    //   elem.msRequestFullscreen();
    // }
    setLoading(true);
    audioContext.volumeDown();
    let existingEmail = null;
    let pendingCred = null;
    let provider = new firebase.auth.FacebookAuthProvider();
    provider.setCustomParameters({
      display: "popup",
    });
    await firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        // let token = result.credential.accessToken;
        let user = result.user;
        let photoURL = user.photoURL + "?width=120";
        localStorage.email = user.email ? user.email : user.displayName;
        localStorage.name = user.displayName;
        localStorage.photo = photoURL;
        let docRef = db
          .collection("users")
          .doc(user.email ? user.email : user.displayName);
        docRef.get().then((doc) => {
          if (doc.exists) {
            if (doc.data().nickName) {
              localStorage.nickName = doc.data().nickName;
            }
            if (doc.data().photo) {
              localStorage.photo = doc.data().photo;
            }
            if (doc.data().score) {
              localStorage.score = doc.data().score;
            }
            docRef
              .update({
                token: localStorage.token ? localStorage.token : "",
              })
              .then((doc) => {
                db.collection("users")
                  .doc(user.email ? user.email : user.displayName)
                  .get()
                  .then((doc) => {
                    audioContext.volumeUp();
                    history.push("/luckygame");
                    setLoading(false);
                  });
              });
          } else {
            db.collection("users")
              .doc(user.email ? user.email : user.displayName)
              .set({
                email: user.email ? user.email : user.displayName,
                name: user.displayName,
                nickName: user.displayName,
                photo: photoURL,
                lastScore: 0,
                lastStatus: "unlucky",
                score: 0,
                type: "h",
                token: localStorage.token ? localStorage.token : "",
                notify: true,
              })
              .then((docRef) => {
                localStorage.nickName = "";
                history.push("/nickname");
              });
          }
        });
      })
      .catch((error) => {
        setLoading(false);
        audioContext.volumeUp();
        if (error.code === "auth/account-exists-with-different-credential") {
          existingEmail = error.email;
          pendingCred = error.credential;
          setExistingEmail(existingEmail);
          setPendingCred(pendingCred);
          return firebase
            .auth()
            .fetchSignInMethodsForEmail(error.email)
            .then((providers) => {
              if (
                providers.indexOf(
                  firebase.auth.GoogleAuthProvider.PROVIDER_ID
                ) !== -1
              ) {
                setOpenAlert(true);
              }
            });
        }
      });
  };
  const handleClickContinue = () => {
    const googProvider = new firebase.auth.GoogleAuthProvider();
    googProvider.setCustomParameters({
      login_hint: existingEmail,
    });
    return firebase
      .auth()
      .signInWithPopup(googProvider)
      .then((result) => {
        localStorage.email = result.user.email;
        localStorage.name = result.user.displayName;
        localStorage.photo = result.user.photoURL + "?width=120";
        db.collection("users")
          .doc(result.user.email)
          .get()
          .then((doc) => {
            localStorage.nickName = doc.data().nickName;
            localStorage.score = doc.data().score;
            setOpenAlert(false);
            history.push("/luckygame");
          });
        return result.user.linkWithCredential(pendingCred);
      });
  };

  const handleClickGuest = () => {
    const elem = document.getElementById("root");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
    history.push("/guest");
  };

  return (
    <>
      {!isOpenAlert ? (
        <>
          {isLoading ? (
            <div className="loader-container">
              <img
                alt="loader"
                src={require(`../../assets/images/SVG/1.svg`)}
                className="loader"
              ></img>
              <div>LOADING LUCKY PAD...</div>
            </div>
          ) : (
            ""
          )}
          <div
            className="signin"
            style={isLoading ? { opacity: 0 } : { opacity: 1 }}
          >
            <img
              alt="logo"
              src={require("./../../assets/images/logo.svg")}
              className="signin-logo"
            ></img>
            <div className="signin-header">
              Connect with Lucky7.
              <div className="signin-header-answer">
                If you wish to use advanced statistics,
                <br /> follow your rank and create or accept challenges
                <br /> from friends, you should login with FB of G.
              </div>
            </div>
            <div className="signin-body">
              <button
                className="signin-body-facebook"
                onClick={handleClickFacebook}
              >
                <img
                  alt="facebook"
                  src={require("./../../assets/images/facebook.svg")}
                  style={{
                    width: "40px",
                    height: "40px",
                    pointerEvents: "none",
                  }}
                ></img>
                <div
                  style={{
                    marginLeft: "35px",
                    pointerEvents: "none",
                  }}
                >
                  FACEBOOK
                </div>
              </button>
              <button
                className="signin-body-google"
                onClick={handleClickGoogle}
              >
                <img
                  alt="google"
                  src={require("./../../assets/images/google.svg")}
                  style={{
                    width: "40px",
                    height: "40px",
                    pointerEvents: "none",
                  }}
                ></img>
                <div
                  style={{
                    marginLeft: "45px",
                    pointerEvents: "none",
                  }}
                >
                  GOOGLE
                </div>
              </button>
              <div>or</div>
              <div className="signin-body-guest">
                <button
                  className="signin-body-guest-button"
                  onClick={handleClickGuest}
                >
                  PLAY AS GUEST
                </button>
                <div className="signin-body-guest-comment">
                  If your wish is just to calculate how <br /> lucky you are
                  right now, simply play as a guest.
                </div>
              </div>
              <div className="signin-body-term">
                <div>
                  With Connecting With Lucky7, <br /> you agree{" "}
                  <Link to="/terms" style={{ color: "white" }}>
                    with terms & conditions
                  </Link>
                </div>
              </div>
              <div className="signin-body-wish">WE WISH YOU A LUCKY DAY!</div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="signin-confirm">
            You already have account with us with email address {existingEmail}{" "}
            <br />
            <br />
          </div>
          <button
            className="signin-confirm-button"
            onClick={handleClickContinue}
          >
            OK
          </button>
        </>
      )}
    </>
  );
};

export default SignIn;
